import api from '../../services/api';

/**
 * Fetches the official region → commune tree for a country.
 *
 * This is the canonical geographic source for the whole platform, for Chile
 * and Mexico alike: shipping-zone coverage, order addresses and any other
 * region/commune picker read from here.
 *
 * @param {string} countryIso2 - ISO2 country code, e.g. "CL" or "MX"
 */
export const getNestedRegionsRequest = async (countryIso2) => {
  return await api.get(`countries/regions/${countryIso2}/nested/`);
};
